const e = {
  page404: {
    title: "Valószínűleg eltévedt",
    message: "Esetleg eltévedt?",
    action_btn: "Vissza az elejére"
  },
  address: {
    title: "Address",
    type: {
      personal: "Magánszemély",
      company: "Vállalkozás"
    },
    organisation: {
      label: "Szervezet"
    },
    name: {
      first_name: "Keresztnév",
      last_name: "Vezetéknév",
      label: "Név"
    },
    contact_person: {
      first_name: "Keresztnév",
      last_name: "Vezetéknév",
      label: "Kapcsolattartó személy"
    },
    street: {
      label: "Utca és házszám",
      address1: "Cím 1",
      address2: "Cím 2"
    },
    city: {
      label: "Település"
    },
    postal_code: {
      label: "Irányítószám"
    },
    country_code: {
      label: "Ország"
    },
    company_data: {
      title: "Cég adatai"
    },
    company_id: {
      label: "Cégjegyzék szám"
    },
    tax_id: {
      label: "Adószám"
    },
    vat_id: {
      label: "Közösségi adószám"
    }
  },
  empty_state: {
    title: "Nothing to show here..."
  },
  profile: {
    emails: {
      label: "E-mail címek (vesszővel elkülönítve)"
    },
    email: {
      label: "E-mail cím"
    },
    phone: {
      label: "Telefonszám",
      short: "Phone"
    }
  },
  validation: {
    country_required: "Először meg kell adnia az országot",
    company_id: {
      not_valid: "Érvénytelen cégjegyzékszám, kérjük, adjon meg másikat"
    },
    tax_id: {
      not_valid: "Érvénytelen adószám, kérjük, adjon meg másikat"
    },
    vat_id: {
      not_valid: "Érvénytelen közösségi adószám, kérjük, adjon meg másikat"
    }
  },
  general: {
    back: "Vissza",
    cancel: "Visszavonás",
    close: "Bezárás",
    remove: "Eltávolít",
    optional: "opcionális",
    period: {
      months: "{period, plural, one {# hónap} other {# hónap}}",
      years: "{period, plural, one {# év} other {# év}}",
      explicit: "Időszak",
      short: {
        months: "{ period, plural, one {hónap} other {# hónap} }",
        years: "{ period, plural, one {év} other {# év} }"
      },
      next: {
        months: "{ period, plural, one {következő hónap} other {következő #  hónap} }",
        years: "{period, plural, one {következő év} other {következő # év}}",
        short: {
          months: "{ period, plural, one {következő hónap} other {következő #  hónap} }",
          years: "{ period, plural, one {következő év} other {következő #  év} }"
        }
      },
      per: {
        months: "{ period, plural, one {hónap} other {#  hónapra} }",
        years: "{ period, plural, one {Évekre} other {#  évre} }",
        short: {
          months: "{ period, plural, one {/hó} other {/#  hónap} }",
          years: "{ period, plural, one {/év} other {/#  évre} }"
        }
      }
    },
    or: "vagy",
    recommended: "ajánlott",
    settings: "Beállítások",
    edit: "Szerkesztés",
    save: "Mentés",
    save_changes: "módosítások mentése",
    reset_form: "űrlap visszaállítása",
    not_available: "nem elérhető",
    unknown_error: "Ismeretlen hiba",
    unknown_error_id: "Ismeretlen hiba ({id})",
    something_went_wrong: "Sajnáljuk, de ez egy nem várt eredmény, valami rosszul ment",
    link: "hivatkozás",
    buy: "Kosárba"
  },
  capslock_hint: {
    line1: "A Caps Lock",
    line2: "be van kapcsolva"
  },
  ws_array_input: {
    some_filtered: "Egyes eredmények érvénytelenek."
  },
  ws_places_input: {
    no_results: "A hely nem található, kérjük próbálja először kevésbé pontosan"
  },
  ws_uploader: {
    validation: {
      file_type: "A fájl típusa nem megfelelő",
      file_size: "A fájl mérete meghaladja a limitet {limit}"
    },
    status: {
      label: "Státusz",
      value: {
        uploaded: "feltöltve",
        uploading: "feltöltés",
        failed: "Sikertelen",
        idle: "idle"
      }
    },
    action: {
      title: "Számlák feltöltése",
      text1: "Fogd és vidd vagy",
      link: "fájl kiválasztása",
      text2: ".",
      abort_tooltip: "Feltöltés megszakítása"
    },
    remove_btn: "Eltávolít"
  },
  ws_table: {
    filter: {
      fulltext_title: "Teljes szöveges keresés",
      data_title: "Adat keresés",
      clear_filters: "Minden szűrő törlése",
      from: "From",
      to: "to"
    },
    label: {
      bulk_actions: "Tömeges műveletek",
      cancel_selection: "Kiválasztás visszavonása",
      item_selected: "kiválasztott elemek",
      selected: "Kiválasztva",
      filterby: "Szűrési feltételek",
      records_per_page: "Rekordok oldalanként:",
      select_all: "Mindet kiválaszt"
    }
  },
  ws_password_strength: {
    rule1: "minimum 8 karakter",
    rule2: "kis- és nagybetű",
    rule3: "legalább egy szám",
    rule4: "legalább egy speciális karakter"
  },
  ws_password_confirmation_input: {
    passwords_do_not_match: "A jelszavak nem egyeznek!"
  },
  ws_two_factor_authentication_input: {
    on_cooldown_one: "You can resend the code again in {{count}} second.",
    on_cooldown_few: "You can resend the code again in {{count}} seconds.",
    on_cooldown_other: "You can resend the code again in {{count}} seconds.",
    resend_code: "Resend code",
    code_being_sent: "Sending 2FA code...",
    code_sent_successfully: "2FA code sent successfully",
    error_sending_code: "Error sending 2FA code",
    invalid_code_pasted: "A bemásolt 2FA kód érvénytelen. Kérjük írd be az érvényes 2FA kódot."
  },
  generate_random: "Jelszó generálás",
  copy: {
    copy: "Másolás",
    copied: "Másolva",
    saved_in_clipboard: "Mentve a vágólapra"
  },
  out_modal: {
    title: "Sajnáljuk, a böngészője<br>nem naprakész",
    text: "Kérlek, frissítse azt a legújabb verzióra, vagy próbáljon meg egy másik böngészőt telepíteni.",
    delimiter_text: "Tudunk segíteni"
  },
  buttons: {
    ok_thanks: "Rendben, köszönöm!"
  },
  payment_cards: {
    ending_with: "Ending with",
    active: "Active"
  },
  ws_sub_items_price_summary: {
    current_price: "Service price (the current billing period)",
    due_now: "Due now",
    next_period_subtraction_warning: "* The price will be deducted from the next billing period",
    next_price: "Service price (the next billing period)"
  },
  dialog_footer: {
    cannot_submit_empty_form: "It is not possible to submit an empty form."
  },
  price_badge: {
    including_vat: "(including VAT)",
    excluding_vat: "(without VAT)"
  },
  login_pages: {
    footer: {
      help: "Segítség",
      terms: "Feltételek",
      privacy: "Adatvédelem"
    },
    help: {
      title: "Segítségre van szükséged?",
      text: "Bármikor elérheted a <a href='{kb_url}' target='_blank'>tudásbázisunkat </a> vagy kapcsolatba léphetsz <a href='{support_url}' target='_blank'>ügyfélszolgálatunkkal</a>."
    }
  },
  message_service: {
    error: {
      axios: {
        title: "Network Error",
        text: "Unable to connect"
      },
      unexpected: {
        title: "Error",
        text: "Unexpected error"
      }
    }
  }
}, t = {
  wsk: e
};
export {
  t as default,
  e as wsk
};
//# sourceMappingURL=wsk.hu-HU-36fd2278.js.map
